module.exports = __webpack_public_path__ + "img/banner_yn.5fa93cf7.png";